/** ******** 商品管理模块 ********* */

// 获取商品卖点列表
export const getSellPointAuditList = {
  url: '/admin/merInfoAudit/getMerInfoAuditList.json',
  method: 'get'
};

// 编辑商品买点
export const saveEditAuditInfo = {
  url: 'admin/merInfoAudit/saveEditAuditInfo.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 通过商品买点 flagType: 1 卖点  2 培训资料
export const passAudit = {
  url: '/admin/merInfoAudit/passAudit.json',
  method: 'post'
};

// 驳回  flagType: 1 卖点  2 培训资料
export const rejectAudit = {
  url: '/admin/merInfoAudit/rejectAudit.json',
  method: 'post'
};

// 查询培训资料审批列表
export const getTrainingMaterialsAuditList = {
  url: '/admin/merMaterialAudit/getMerTrainLinkAuditList.json',
  method: 'get'
};

// 卖点和培训资料列表
export const getSellPointAndMaterialsList = {
  url: '/admin/superMerIntroduction/getSuperMerIntroductionInfo.json',
  method: 'get'
};

// 品牌卖点导入
export const importSellPointFile = {
  url: '/admin/superMerIntroduction/importMerIntroduction.json'
};

// 培训资料导入
export const importMaterialsFile = {
  url: '/admin/superMerIntroduction/importTrainLink.json'
};

// 品牌热点和培训资料 全部导出
export const exportMerIntroductionExcel = {
  url: '/admin/superMerIntroduction/exportMerIntroductionAsync.json'
};

// 批量添加店铺商品查询
export const getMerInfoList = {
  url: '/admin/superMerIntroduction/getMerInfoList.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 查询添加商品是否已存在

export const checkProduct = {
  url: '/admin/superMerIntroduction/getIsExistsMer.json',
  method: 'post'
};

// 批量添加
export const batchAddMerInfo = {
  method: 'post',
  url: '/admin/superMerIntroduction/batchSaveMerIntroductioin.json',
  // config: {
  //   headers: { 'Content-Type': 'multipart/form-data' }
  // }
};

// 删除
export const delMerInfo = {
  url: '/admin/superMerIntroduction/deleteMerIntroduction.json',
  method: 'post'
};
